// Stable per-browser anonymous id for the Paddle rollout ramp's purchase-first
// (logged-out) bucketing (#3910). A logged-out buyer has no identity yet and the
// client cannot read the config DB, so the provider is bucketed on this id
// instead — minted once and reused so the buyer gets a CONSISTENT provider
// across page reloads. It identifies the browser, not the user, so it must
// SURVIVE signOut: the literal below is registered in
// local-storage-hygiene.ts (DEVICE_LEVEL_LOCALSTORAGE_KEYS) — keep the two in
// sync (a matching hygiene test cross-checks the literal). See
// design-docs/paddle-integration.md ("Phase 2 — Paddle for new users in production (the percentile ramp)").

// localStorage key holding the anon bucket id. Must match the entry in
// local-storage-hygiene.ts DEVICE_LEVEL_LOCALSTORAGE_KEYS.
export const PADDLE_BUCKET_ID_KEY = 'cs-paddle-bucket-id';

/** Return the stable per-browser anon bucket id, minting + persisting one on
 *  first use. */
export function getPaddleBucketId(): string {
  let id = localStorage.getItem(PADDLE_BUCKET_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(PADDLE_BUCKET_ID_KEY, id);
  }
  return id;
}
